import React from 'react';
import {Platform, StyleProp, StyleSheet, View, ViewStyle} from 'react-native';
import FontAwesome5Pro from '../icons/FontAwesomeIcon';
import NavActions from 'src/actions/NavActions';
import Styles from '../Styles';
import Header from './Header';
import AVTouchableOpacity from './AVTouchableOpacity';
import Settings from 'src/Settings';
import BackIcon from 'src/components/img/svg/BackIcon';
import BackArrow365 from 'src/components/img/svg/BackArrow365';
import Localized from 'src/constants/AppStrings';
import {getLayoutDescriber} from './layoutDescriptor/DescriptorType';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const {headerContainerStyleDescriptor, getBackIconColor} = getLayoutDescriber();

type BackSubheaderProps = {
  onBackSelect?: () => void | Promise<void>;
  style?: any;
  title: string | string[];
  popToTop?: boolean;
  textStyle?: any;
  pop?: boolean;
  rightView?: React.ReactNode;
  bottomView?: React.ReactNode;
  children?: React.ReactNode;
  previousRoute?: string;
  checkout?: boolean;
  accessibilityLabel?: string;
  accessibilityHint?: string;
  contentStyle?: StyleProp<ViewStyle>;
  transparentHeader?: boolean;
  onboardingHeader?: boolean;
  testId?: string;
};

const touchTargetWidth = Settings.isNewUI()
  ? Styles.Heights.touchTargetHeight1
  : Styles.Heights.touchTargetHeight2;

const touchTargetHeight = Settings.isNewUI()
  ? Styles.Heights.headerIconHeight
  : Styles.Heights.touchTargetHeight2;

const BackSubheader = (props: BackSubheaderProps) => {
  const onBackSelect = () => {
    if (props.pop) {
      if (props.popToTop) {
        NavActions.popToTop();
      } else {
        NavActions.pop();
      }
    }

    if (props.onBackSelect) {
      props.onBackSelect();
    }
  };

  const checkbackArrowColor = () => {
    return Platform.OS === 'web'
      ? Styles.Colors.PayNew.black01
      : Styles.Colors.PayNew.white01;
  };

  const getBackIconView = () => {
    if (Settings.isNewUI()) {
      if (
        Settings.buildType === BuildTypeEnum.default ||
        Platform.OS == 'web'
      ) {
        return (
          <BackArrow365
            fill={props.transparentHeader ? '#000' : checkbackArrowColor()}
          />
        );
      } else {
        return (
          <BackIcon
            size={22}
            color={
              props.onboardingHeader
                ? '#111111'
                : getBackIconColor(props.transparentHeader)
            }
          />
        );
      }
    }
    return (
      <FontAwesome5Pro
        name="chevron-left"
        color={Styles.Colors.PayNew.black01}
        size={Styles.Fonts.f2}
        style={styles.backIcon}
        light
      />
    );
  };
  return (
    <Header
      title={props.title}
      testId={props.testId}
      rightView={props.rightView}
      onTitlePress={onBackSelect}
      style={props.style}
      contentStyle={props.contentStyle}
      transparentHeader={props.transparentHeader}
      onboardingHeader={props.onboardingHeader}
      checkout={props.checkout}
      leftView={
        <AVTouchableOpacity
          accessible
          testID="qa_btn_Back"
          nativeID="qa_btn_Back"
          style={[
            styles.close,
            {
              paddingLeft: Settings.isRefiveAnd365Pay() ? 0 : Styles.Spacing.m0,
            },
            Platform.OS === 'web' &&
              props.title === Localized.Labels.notifications && {
                display: 'none',
              },
          ]}
          accessibilityHint={'back'}
          accessibilityLabel={'back'}
          accessibilityRole={'button'}
          onPress={onBackSelect}
          hitSlop={Styles.HitSlop_8}
        >
          {
            <View style={headerContainerStyleDescriptor().headerTextContainer}>
              {getBackIconView()}
            </View>
          }
        </AVTouchableOpacity>
      }
      bottomView={props.bottomView}
    >
      {props.children}
    </Header>
  );
};

BackSubheader.defaultProps = {
  popToTop: false,
  pop: true,
};

const styles = StyleSheet.create({
  backIcon: {
    marginVertical: Styles.Spacing.m2,
  },
  close: {
    alignItems: Platform.OS === 'web' ? 'flex-end' : 'flex-start',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',

    paddingTop:
      Platform.OS === 'web' ? Styles.Spacing.m1 / 2 : Styles.Spacing.m0,
    height: Platform.OS === 'web' ? undefined : touchTargetHeight,
    width: Platform.OS === 'web' ? undefined : touchTargetWidth,
  },
});

export default BackSubheader;
